import { render, staticRenderFns } from "./CastingReportPage.vue?vue&type=template&id=28f62b60"
import script from "./CastingReportPage.vue?vue&type=script&lang=js"
export * from "./CastingReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports